module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "Joinbanner"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "AboutUs"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "greyBox"
  }, [_c('div', {
    staticClass: "GreyBoxx JoinUs"
  }, [_c('h4', [_vm._v("加入我们")]), _vm._v(" "), _c('p', [_vm._v("我们正在寻找才华横溢，怀揣梦想的小伙伴，和我们一起做充满挑战的事业")]), _c('span', {
    on: {
      "click": _vm.join
    }
  }, [_vm._v("前往加入我们  >")])]), _vm._v(" "), _c('div', {
    staticClass: "GreyBoxx BusinessCooper"
  }, [_c('h4', [_vm._v("商务合作")]), _vm._v(" "), _c('p', [_vm._v("输出整场运营方案，快速吸粉、多店智能管理、利润翻翻")]), _c('span', {
    on: {
      "click": _vm.cooperations
    }
  }, [_vm._v("前往商务合作 >")])]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MethodsBanner"
  }, [_c('img', {
    staticClass: "MethodsPic",
    attrs: {
      "src": require("../assets/aboutbanner.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "AboutBanner",
    attrs: {
      "src": require("../assets/AboutWords.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-title"
  }, [_c('h4', [_vm._v("关于我们")]), _vm._v(" "), _c('p', [_vm._v("About us")]), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "greyLine"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BannerPic"
  }, [_c('div', {
    staticClass: "swiper-container gallery-top"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/1)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/2)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/3)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/4)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/5)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/6)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/7)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-container gallery-thumbs"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/1)",
      "margin-right": "6px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/2)",
      "margin-right": "6px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/3)",
      "margin-right": "6px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/4)",
      "margin-right": "6px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/5)",
      "margin-right": "6px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/6)",
      "margin-right": "6px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    staticStyle: {
      "background-image": "url(http://lorempixel.com/1200/1200/nature/7)",
      "margin-right": "6px"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BusinessInformation"
  }, [_c('p', {
    staticClass: "Iconn"
  }, [_vm._v("\n\n          < 展会现场")]), _vm._v(" "), _c('h4', {
    staticClass: "businessTitle"
  }, [_vm._v("广州好酷信息科技有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "BusinessContent"
  }, [_vm._v("是游戏游艺行业的一站式服务平台，包括运营管理、销售推广、供应链服务等。我司研发的“酷酷宝线上综合管理系统”精准解决行业全流程痛点，帮助经营者轻松实现了“互联网+”、 建立生态圈、模式转型升级和盈利倍增。"), _c('br'), _c('br'), _vm._v(" 2016年9月，广州好酷信息科技有限公司成立，获得1200万天使轮融资，股东方代表：腾讯讯加微公司、行业合伙人、佶星雨团队等。16年11月，酷酷宝系统总粉丝数量超过200万；酷酷宝设备接入数超过3万+；酷酷宝系统总粉丝数超过500万+；酷酷宝线上营收超2000w+。\n\n              "), _c('br'), _c('br'), _vm._v(" 公司创始人伍玉民先生，有着二十多年的行业经验，带领着一群来自“YY”、“金蝶”的IT精英，致力于游戏游艺这个细分领域的深耕，同时引入了行业合伙人和x腾讯公司等各方的资金资源支持，秉承“开放合作、连接共赢”的企业精神，与各届同仁共同打造游戏游艺产业生态系统！\n\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "GreyBoxx communicate"
  }, [_c('h4', [_vm._v("联系我们")]), _vm._v(" "), _c('p', [_vm._v("地址：广州市番禺区东环街555号番禺节能科技园内科技创新大厦618")]), _c('span', {
    attrs: {
      "id": "telephone"
    }
  }, [_vm._v("联系电话：020-12345678")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f6820e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about.vue
// module id = 278
// module chunks = 1